import { css } from 'styled-components';

/**
 * The app's TreeTable expander: a solid caret that points right when collapsed and rotates 90°
 * when expanded. PrimeReact ships no theme CSS here, and its own toggler icon is a stroked
 * chevron, so the glyph is painted as a `currentColor` mask over the hidden default svg.
 *
 * Extracted from `OrgTable.styles.ts` and `AccessTable/AccessTable.styles.ts`, which had the same
 * block inline twice. Apply it on the element that wraps the `.p-treetable` — it styles the
 * toggler and the two `tr[aria-expanded]` rotation states together. The glyph is a fixed 6:11
 * path, so `width`/`height` only set the box it is drawn into.
 */
const CARET =
  "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 11\"><path d=\"M0 0.660586L0 9.88773C0 10.0664 0.0652145 10.2208 0.195535 10.3512C0.326 10.4817 0.480415 10.5469 0.658925 10.5469C0.837435 10.5469 0.991959 10.4817 1.12235 10.3512L5.73587 5.73764C5.86634 5.60703 5.93166 5.45262 5.93166 5.27414C5.93166 5.09567 5.86634 4.94111 5.73587 4.81075L1.12231 0.197161C0.991958 0.0668401 0.837434 0.00140949 0.658888 0.0014095C0.480414 0.00140951 0.325999 0.0668039 0.195498 0.197161C0.0650696 0.327518 0 0.482077 0 0.660586Z\"/></svg>') no-repeat center";

export const treeTogglerCaret = (width = 6, height = 11) => css`
  .p-treetable-toggler {
    position: relative;

    svg {
      opacity: 0;
      position: absolute;
      pointer-events: none;
    }

    &::before {
      content: '';
      display: block;
      width: ${width}px;
      height: ${height}px;
      background-color: currentColor;
      mask: ${CARET};
      -webkit-mask: ${CARET};
      transition: transform 0.1s ease;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  tr[aria-expanded='false'] .p-treetable-toggler::before,
  tr:not([aria-expanded]) .p-treetable-toggler::before {
    transform: translate(-50%, -50%);
  }

  tr[aria-expanded='true'] .p-treetable-toggler::before {
    transform: translate(-50%, -50%) rotate(90deg);
  }
`;
